export default "__VITE_ASSET__D4VeUPAo__"